import React from 'react';
import styled from '@emotion/styled';
import { breakpoints, OutboundLink } from 'gatsby-theme-apollo';
import Section from './section';
import { Flex } from './flex';

const LookAheadRoot = styled.div({
  display: `none`,
  [breakpoints.xxl]: {
    display: `flex`
  }
});

const LookAheadLink = styled(OutboundLink)({
  margin: `0px 10px`,
  fontWeight: `bold`
});

const LookAheadTable = ({ links }) => {
  return (
    <LookAheadRoot>
      <Section>
        <Flex width="100%">
          {links &&
            links.map(({ text, href }, index) => {
              return (
                <React.Fragment key={index}>
                  <LookAheadLink href={href}>{text}</LookAheadLink>
                  {index !== links.length - 1 && `|`}
                </React.Fragment>
              );
            })}
        </Flex>
      </Section>
    </LookAheadRoot>
  );
};

export default LookAheadTable;
